<template>
  <span :class="ns.b()">
    <Icon :class="ns.e('icon')">
      <svg :class="ns.e('loading')" viewBox="0 0 50 50">
        <circle class="path" cx="25" cy="25" r="20" fill="none" />
      </svg>
    </Icon>
    <span v-if="$slots?.default" :class="ns.e('text')">
      <slot />
    </span>
  </span>
</template>

<script lang="ts" setup>
import { useNamespace } from '@xzx-design/hooks'
import { Icon } from '@xzx-design/components'
import { loadingProps } from './loading'

defineOptions({
  name: 'XzxLoading',
})

defineProps(loadingProps)

const ns = useNamespace('loading')
// init here
</script>
